import { SORT_TYPES } from './constants';
import { dateCompare } from './dateUtils';

export const EnrollmentConnectionStatusEnum = {
  CONNECTED: 'connected',
  PENDING: 'pending',
  REVOKED: 'revoked',
  DISCONNECTED: 'disconnected',
  EXPIRED: 'expired',
  NONE: 'none',
  ACTIVE: 'Active',
  ENROLLED: 'Enrolled',
  COMPLETED: 'Completed',
  COMPLETE: 'Complete',
};
Object.freeze(EnrollmentConnectionStatusEnum);

export const getEnrollmentConnectionStatusesOrder = () => [
  EnrollmentConnectionStatusEnum.CONNECTED,
  EnrollmentConnectionStatusEnum.PENDING,
  EnrollmentConnectionStatusEnum.REVOKED,
  EnrollmentConnectionStatusEnum.DISCONNECTED,
  EnrollmentConnectionStatusEnum.EXPIRED,
  EnrollmentConnectionStatusEnum.NONE,
  EnrollmentConnectionStatusEnum.ACTIVE,
  EnrollmentConnectionStatusEnum.ENROLLED,
  EnrollmentConnectionStatusEnum.COMPLETED,
];

export const getPendingOrConnectedEnrollmentsByEndDate = (enrollments = []) =>
  enrollments
    .sort((c, d) => dateCompare(c.endDate, d.endDate, SORT_TYPES.DESC))
    .filter(
      c =>
        c.connectionStatus === EnrollmentConnectionStatusEnum.CONNECTED ||
        c.connectionStatus === EnrollmentConnectionStatusEnum.PENDING,
    );

/**
 * Delete the property if it is not marked as visible in teamPatientFields config (KPA configuration)
 * @param {Array} fields
 * @param {obj} patient
 * @param {obj} teamPatientFieldsConfig
 * @returns
 */
export const checkFieldConfigAndDeleteProperty = (
  fields,
  patient,
  teamPatientFieldsConfig,
) => {
  fields.forEach(fieldName => {
    const fieldConfig = teamPatientFieldsConfig[fieldName];
    if (fieldConfig) {
      const { isVisible } = fieldConfig;
      if (isVisible) {
        return;
      }
    }
    delete patient[fieldName]; // eslint-disable-line
  });
  return patient;
};

/**
 * converts teamPatientFields into an object (fieldName and config mapping)
 * @param {Array} patientFields
 * @returns {obj}
 */
export const formatPatientFields = patientFields => {
  return (
    (patientFields &&
      patientFields.reduce((prev, curr) => {
        const { fieldName, ...curFieldConfig } = curr;
        return { ...prev, [curr.fieldName]: { ...curFieldConfig } };
      }, {})) ||
    {}
  );
};
/**
 * To get the teamPatientFields config as object)
 * @param {Array} teams
 * @returns {obj}
 */
export const getTeamPatientFieldsConfig = teams => {
  const { teamPatientFields } = (teams && teams[0]) || [];
  const formatPatientFieldsRes = formatPatientFields(teamPatientFields);
  return {
    ...formatPatientFieldsRes,
    orderingPhysician: formatPatientFieldsRes.orderingPhysicianMemberID,
  };
};



// WEBPACK FOOTER //
// ./src/common/enrollmentUtils.js